import { createContext } from 'react';

// A fresh collector is supplied for each static render; browsers update the head.
export const SEOContext = createContext(null);
